import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthFeatures = () => {
  const features = [
    {
      icon: 'Target',
      title: '목표 추적',
      description: '챌린지를 생성하고 진행 상황을 시각적으로 확인하세요'
    },
    {
      icon: 'Image',
      title: '증명 시스템',
      description: '이미지로 달성을 증명하고 별점을 받으세요'
    },
    {
      icon: 'Award',
      title: '업적 수집',
      description: '완료한 챌린지를 아카이브에 보관하세요'
    },
    {
      icon: 'TrendingUp',
      title: '진행 분석',
      description: '통계와 그래프로 성장을 확인하세요'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-8 md:mt-10 lg:mt-12">
      {features?.map((feature, index) => (
        <div
          key={index}
          className="flex items-start space-x-3 md:space-x-4 p-4 md:p-5 bg-card/50 rounded-lg border border-border hover:border-primary/50 transition-gaming"
        >
          <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-primary/20 rounded-md flex items-center justify-center">
            <Icon name={feature?.icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">
              {feature?.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground caption">
              {feature?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuthFeatures;